<template>
  <div class="embodyDetails">
    <van-sticky>
      <div
        class="embodyDetailsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle"
          >{{ data.withdrawal_type == 1 ? "个人" : "企业" }}提现详情</span
        >
      </div>
    </van-sticky>
    <div class="content">
      <div class="tip" v-if="data.status == 1">
        提现订单将会在1～7个工作日内进行审核，请您耐心等待
      </div>
      <div class="card top">
        <span>提现金额</span>
        <h3>¥{{ data.money }}</h3>
        <p v-if="data.status == 1">审核中</p>
        <p v-if="data.status == 2">已完成</p>
        <p v-if="data.status == -1">已驳回</p>
      </div>
      <div class="card mid">
        <h3>提现信息</h3>
        <div class="item">
          <div class="itemLeft">
            <span>订单编号：</span>
            <p>{{ data.order_sn }}</p>
            <img
              @click="copy()"
              id="copycode"
              :data-clipboard-text="data.order_sn"
              src="./../../../assets/decoration/copy.png"
              alt=""
            />
          </div>
        </div>
        <div class="item">
          <div class="itemLeft">
            <span>申请时间：</span>
            <p>{{ data.created_at }}</p>
          </div>
        </div>
        <div class="item" v-if="data.status == 2">
          <div class="itemLeft">
            <span>{{ data.withdrawal_type == 1 ? "到账" : "完成" }}时间：</span>
            <p>{{ data.audited_at }}</p>
          </div>
          <div
            class="itemRight"
            @click="seeVoucher()"
            v-if="data.withdrawal_type == 2"
          >
            <span>凭证</span>
            <img src="./../../../assets/decoration/right.png" alt="" />
          </div>
        </div>
        <div class="item" v-if="data.status == -1">
          <div class="itemLeft">
            <span>驳回时间：</span>
            <p>{{ data.audited_at }}</p>
          </div>
        </div>
        <div class="item" v-if="data.status == -1">
          <div class="itemLeft">
            <span>驳回原因：</span>
            <p>{{ data.reason }}</p>
          </div>
        </div>
      </div>
      <div class="card bom" @click="seeInvoice()">
        <div>
          <img src="./../../../assets/decoration/invoice.png" alt="" />
          <h3>查看发票</h3>
        </div>
        <div>
          <span>{{ data.voucher ? data.voucher.length : "" }}张</span>
          <img src="./../../../assets/decoration/right.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      isiOSX: false,
      id: null,
      data: {},
      type: 1,
      isToken: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
      sessionStorage.setItem("token", JSON.stringify(this.$route.query.token));
      this.isToken = true;
    } else {
      this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
      this.isToken = false;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      if (this.isToken) {
        this.params("", "", "goBack");
      } else {
        this.$router.go(-1);
      }
    },
    getData() {
      let apiUrl = "";
      if (this.type == 1) {
        apiUrl = "decoration/member/withdrawal/city/agent/show";
      } else {
        apiUrl = "decoration/member/withdrawal/city/partner/show";
      }
      this.$api
        .get(apiUrl, {
          id: this.id,
        })
        .then((res) => {
          this.data = res;
        });
    },
    // 查看发票
    seeInvoice() {
      ImagePreview({
        images: this.data.voucher,
        startPosition: 0,
      });
    },
    // 查看凭证
    seeVoucher() {
      ImagePreview({
        images: this.data.pay_thumbs,
        startPosition: 0,
      });
    },
    copy() {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        this.$toast("复制失败");
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less">
.embodyDetails {
  min-height: 100%;
  background: #f5f6ff;
  .embodyDetailsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    .tip {
      background: rgba(255, 219, 198, 0.9);
      font-size: 14px;
      color: #ff7e31;
      line-height: 20px;
      padding: 10px 9px 10px 16px;
    }
    .card {
      background: #ffffff;
      border-radius: 12px;
      padding: 24px;
      margin: 12px 16px 0;
      h3 {
        margin: 0;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
      }
      .item {
        font-size: 15px;
        line-height: 21px;
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        .itemLeft {
          display: flex;
          span {
            color: #999999;
            flex-shrink: 0;
          }
          p {
            color: #333333;
            word-break: break-all;
          }
          img {
            width: 16px;
            height: 16px;
            margin-left: 6px;
            margin-top: 2.5px;
          }
        }
        .itemRight {
          display: flex;
          align-items: center;
          span {
            color: #999999;
          }
          img {
            width: 12px;
            height: 12px;
          }
        }
      }
    }
    .top {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
      }
      h3 {
        font-size: 24px;
        color: #333333;
        line-height: 33px;
        margin: 16px 0;
      }
      p {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
      }
    }
    .bom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        display: flex;
        align-items: center;
        img {
          width: 14px;
          height: 14px;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
          color: #999999;
          line-height: 20px;
        }
      }
      div:last-child {
        img {
          width: 12px;
          height: 12px;
          margin: 0;
        }
      }
    }
  }
}
</style>